export default __webpack_public_path__ + "static/hero_about_img_2-2f6e463f72c1de01c93723f3f26140ad.png";